import React, { useRef, useState } from 'react';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import styles from './DriveQueryHelpHint.module.scss';

const DriveQueryHelpHint = ({ field }) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  const description =
    field?.description ||
    'Drive query to filter files. The query is composed with a createdTime boundary so the trigger only fires for newly created files.';
  const examples = field?.examples?.length
    ? field.examples
    : [
        "name contains 'report'",
        "mimeType = 'application/pdf'",
        "name contains 'project' and mimeType != 'application/vnd.google-apps.folder'",
      ];

  return (
    <>
      <IconButton
        ref={anchorRef}
        type="button"
        size="small"
        className={styles.helpBtn}
        aria-label="Drive query examples"
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <HelpOutline fontSize="inherit" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={hide}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableRestoreFocus
        className={styles.popover}
        slotProps={{
          paper: {
            className: styles.popoverPaper,
            onMouseEnter: show,
            onMouseLeave: hide,
          },
        }}
      >
        <Box className={styles.content}>
          <Typography variant="subtitle2" className={styles.title}>
            Drive query
          </Typography>
          <Typography variant="body2" className={styles.description}>
            {description}
          </Typography>
          <Typography variant="caption" className={styles.examplesTitle}>
            Examples
          </Typography>
          <ul className={styles.examplesList}>
            {examples.map((example) => (
              <li key={example}>
                <code>{example}</code>
              </li>
            ))}
          </ul>
        </Box>
      </Popover>
    </>
  );
};

export default DriveQueryHelpHint;
